package com.ustadmobile.core.domain.clazzenrolment.pendingenrolment

class AlreadyHasPendingRequestException: IllegalStateException()
